var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLink = function SvgLink(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M9.9 1a.9.9 0 0 0 0 1.8h2.028L7.264 7.46a.9.9 0 0 0 1.272 1.273l4.666-4.661V6.1a.9.9 0 1 0 1.8 0V1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M2.803 6.9c0-1.16.94-2.1 2.1-2.1H6.9a.9.9 0 0 0 0-1.8H4.903a3.9 3.9 0 0 0-3.9 3.9v4.204a3.9 3.9 0 0 0 3.9 3.9h4.2a3.9 3.9 0 0 0 3.9-3.9v-2a.9.9 0 1 0-1.8 0v2a2.1 2.1 0 0 1-2.1 2.1h-4.2a2.1 2.1 0 0 1-2.1-2.1z"
  })));
};
export { SvgLink as ReactComponent };